<div class="toolbar-container">
  <rt-button
    #origin
    *ngFor="let button of buttons; let i = index; trackBy: trackByValue"
    (click)="onButtonClick(button, origin.elRef.nativeElement)"
    [class.active]="buttonsState[i]"
    variant="plain only-icon small-x"
  >
    <rt-icon
      [color]="buttonsState[i] ? IconColor.Primary : IconColor.White"
      [name]="button.icon"
    ></rt-icon>
    {{ button.name }}
  </rt-button>
</div>
<div class="arrow"></div>
